import { useNavigate } from 'react-router-dom';
import { Layout, ErrorNotice } from '../components/Layout';
import { useCapture } from '../context/capture';
import { useState } from 'react';

export function CapturePage() {
  const navigate = useNavigate();
  const { setCapture, templateType, setTemplateType } = useCapture();
  const [error, setError] = useState('');
  const choose = (file?: File) => {
    if (!file) return;
    const isPdf = /\.pdf$/i.test(file.name)
      && (file.type === 'application/pdf' || file.type === '' || file.type === 'application/octet-stream');
    if (file.size > (isPdf ? 20 : 25) * 1024 * 1024) { setError(`ไฟล์ต้นฉบับใหญ่เกิน ${isPdf ? 20 : 25} MB กรุณาลดขนาดก่อน`); return; }
    if (!isPdf && !file.type.startsWith('image/') && !/\.(heic|heif)$/i.test(file.name)) {
      setError('กรุณาเลือก PDF หรือไฟล์รูปภาพ JPEG, PNG, HEIC หรือ WebP'); return;
    }
    setCapture(file);
    navigate('/capture/edit');
  };
  return (
    <Layout title="เพิ่มเอกสารนัดหมาย">
      <section className="mx-auto max-w-lg space-y-5">
        <div className="card space-y-3">
          <div>
            <h2 className="text-lg font-bold">เลือกประเภทเอกสาร</h2>
            <p className="mt-1 text-sm text-slate-600">ระบบจะใช้รูปแบบนี้เพื่อค้นหาวัน เวลา และข้อมูลที่เหมาะสม</p>
          </div>
          {([
            ['meeting', 'นัดประชุม', 'วันประชุม เวลา สถานที่ วาระ และผู้ติดต่อ'],
            ['task', 'สิ่งที่ต้องทำ', 'ชื่องาน กำหนดส่ง และงานที่เกี่ยวข้องกับการประชุม'],
            ['medical', 'นัดแพทย์', 'สถานพยาบาล แผนก แพทย์ และคำแนะนำ'],
          ] as const).map(([value, label, description]) => (
            <label key={value} className={`flex min-h-16 cursor-pointer items-start gap-3 rounded-2xl border p-3 ${templateType === value ? 'border-teal-600 bg-teal-50' : 'border-slate-200'}`}>
              <input type="radio" name="templateType" value={value} checked={templateType === value} onChange={() => setTemplateType(value)} className="mt-1 h-5 w-5 accent-teal-700" />
              <span><span className="block font-semibold">{label}</span><span className="text-sm text-slate-600">{description}</span></span>
            </label>
          ))}
        </div>
        <div className="card text-center">
          <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-teal-50 text-5xl">📷</div>
          <h2 className="mt-5 text-xl font-bold">อัปโหลดไฟล์เอกสาร</h2>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">บนคอมพิวเตอร์เลือกไฟล์จากเครื่อง ส่วนโทรศัพท์สามารถถ่ายภาพหรือเลือกไฟล์ได้ ข้อมูลจะให้คุณตรวจสอบก่อนบันทึกเสมอ</p>
          <label className="btn-secondary mt-6 w-full cursor-pointer md:hidden">
            ถ่ายรูปใบนัด
            <input className="sr-only" type="file" accept="image/*,.heic,.heif" capture="environment" onChange={(event) => choose(event.target.files?.[0])} />
          </label>
          <label className="btn-primary mt-3 w-full cursor-pointer md:mt-6">
            เลือกไฟล์เอกสารจากเครื่อง
            <input className="sr-only" type="file" accept="image/*,.heic,.heif,application/pdf,.pdf" onChange={(event) => choose(event.target.files?.[0])} />
          </label>
        </div>
        {error && <ErrorNotice message={error} />}
        <p className="px-3 text-center text-xs text-slate-500">รองรับ PDF สูงสุด 20 MB และภาพ JPEG, PNG, HEIC/HEIF, WebP ระบบอ่าน PDF สูงสุด 20 หน้า</p>
      </section>
    </Layout>
  );
}
